import { render, staticRenderFns } from "./ApprovalRead.vue?vue&type=template&id=3414b2b1&scoped=true"
import script from "./ApprovalRead.vue?vue&type=script&lang=js"
export * from "./ApprovalRead.vue?vue&type=script&lang=js"
import style0 from "./ApprovalRead.vue?vue&type=style&index=0&id=3414b2b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3414b2b1",
  null
  
)

export default component.exports